<template>
  <div class="container grid-lg mb-2 p-0" aria-labelledby="header-title">
    <Header title="Export"></Header>

    <div class="container grid-sm">
      <form class="form-horizontal">
        <div class="form-group">
          <div class="col-4 col-sm-12">
            <label class="form-label" for="format">Format</label>
          </div>
          <div class="col-8 col-sm-12">
            <select v-model="format" id="format" class="form-select select-lg">
              <option value="matpower">MATPOWER</option>
              <option value="raw">RAW</option>
              <option value="json">JSON</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="col-4 col-sm-12">
            <label class="form-label" for="casename">Case Name</label>
          </div>
          <div class="col-8 col-sm-12">
            <div class="input-group">
              <input
                v-model.number="casename"
                class="form-input input-lg"
                id="casename"
              />
            </div>
            <p v-if="!$v.casename.required" class="form-input-hint">
              Case name is required.
            </p>
          </div>
        </div>
        <div class="form-group">
          <div class="col-4 col-sm-12"></div>
          <div class="col-8 col-sm-12">
            <div>
              <button
                v-on:click="exportCase"
                v-bind:class="{
                  disabled: !Module.ready || !$v.casename.required
                }"
                type="button"
                class="btn btn-primary"
              >
                <download-icon size="1x" class="icon" />
                Export
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { saveAs } from "file-saver";

import { DownloadIcon } from "vue-feather-icons";

import Header from "../components/Header";
import MPCStore from "../stores/MPCStore";
import IOStore from "../stores/IOStore";
import Module from "../module";

export default {
  name: "Export",
  components: {
    Header,
    DownloadIcon
  },
  data() {
    return {
      Module: Module.data,
      format: "matpower",
      casename: "case" + MPCStore.methods.getBuses().length
    };
  },
  methods: {
    exportCase() {
      if (this.format === "json") {
        let mpc = MPCStore.methods.getMPC();
        let data = JSON.stringify(mpc, null, "  ");

        let blob = new Blob([data], {
          type: "application/json;charset=utf-8"
        });
        saveAs(blob, this.casename + ".json");
      } else if (this.format === "matpower") {
        let mpc = MPCStore.methods.getMPC();
        let casename = this.casename;
        Module.methods
          .saveCase(mpc, this.casename)
          .catch(err => {
            IOStore.methods.error(err.message);
            IOStore.methods.output(err.output);
          })
          .then(function(resp) {
            let blob = new Blob([resp.retval.mpc], {
              type: "text/x-matlab;charset=utf-8"
            });
            saveAs(blob, casename + ".m");
          });
      } else if (this.format === "raw") {
        let mpc = MPCStore.methods.getMPC();
        let casename = this.casename;
        Module.methods
          .saveRaw(mpc)
          .catch(err => {
            IOStore.methods.error(err.message);
            IOStore.methods.output(err.output);
          })
          .then(resp => {
            IOStore.methods.output(resp.output);
            let blob = new Blob([resp.retval.raw], {
              type: "text/plain;charset=utf-8"
            });
            saveAs(blob, casename + ".raw");
          });
      }
    }
  },
  validations() {
    return {
      casename: {
        required: required
      }
    };
  }
};
</script>
